import { render } from "./TooltipKanal.vue?vue&type=template&id=4250e4d6&scoped=true"
import script from "./TooltipKanal.vue?vue&type=script&lang=js"
export * from "./TooltipKanal.vue?vue&type=script&lang=js"

import "./TooltipKanal.vue?vue&type=style&index=0&id=4250e4d6&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4250e4d6"]])

export default __exports__